// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ColorVariants":"bbf_a bhm_i bhm_j","ColorVariants__color":"bbf_b bhm_rp","ColorVariants__more":"bbf_c bhm_vv"};